export const TEST = 'TEST';
export const SET_TELEGRAM_STATUS = 'SET_TELEGRAM_STATUS';
export const SET_AUTHORIZATION_STATUS = 'SET_AUTHORIZATION_STATUS';
export const SET_LINK_SCROLL_STATUS = 'SET_LINK_SCROLL_STATUS';

export const TELEGRAM_AUTHORIZATION_STARTED = 'TELEGRAM_AUTHORIZATION_STARTED';
export const TELEGRAM_AUTHORIZATION_SUCCESS = 'TELEGRAM_AUTHORIZATION_SUCCESS';
export const TELEGRAM_AUTHORIZATION_FAILURE = 'TELEGRAM_AUTHORIZATION_FAILURE';

export const TELEGRAM_WIDGET_AUTHORIZATION_STARTED = 'TELEGRAM_WIDGET_AUTHORIZATION_STARTED';
export const TELEGRAM_WIDGET_AUTHORIZATION_SUCCESS = 'TELEGRAM_WIDGET_AUTHORIZATION_SUCCESS';
export const TELEGRAM_WIDGET_AUTHORIZATION_FAILURE = 'TELEGRAM_WIDGET_AUTHORIZATION_FAILURE';

export const GOOGLE_WIDGET_AUTHORIZATION_STARTED = 'GOOGLE_WIDGET_AUTHORIZATION_STARTED';
export const GOOGLE_WIDGET_AUTHORIZATION_SUCCESS = 'GOOGLE_WIDGET_AUTHORIZATION_SUCCESS';
export const GOOGLE_WIDGET_AUTHORIZATION_FAILURE = 'GOOGLE_WIDGET_AUTHORIZATION_FAILURE';

export const CLASSIC_REGISTRATION_STARTED = 'CLASSIC_REGISTRATION_STARTED';
export const CLASSIC_REGISTRATION_SUCCESS = 'CLASSIC_REGISTRATION_SUCCESS';
export const CLASSIC_REGISTRATION_FAILURE = 'CLASSIC_REGISTRATION_FAILURE';

export const CLASSIC_LOGIN_STARTED = 'CLASSIC_LOGIN_STARTED';
export const CLASSIC_LOGIN_SUCCESS = 'CLASSIC_LOGIN_SUCCESS';
export const CLASSIC_LOGIN_FAILURE = 'CLASSIC_LOGIN_FAILURE';

export const RESET_PASSWORD_STARTED = 'RESET_PASSWORD_STARTED';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';





